import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ctAppRoles: [],
  approvedRegions: [],
  approvedPlants: [],
  regionPlantMapping: {}, // store full mapping for Header
  selectedRegion: "",
  selectedPlant: "",
  email: "",
  name: ""
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCtAppRoles: (state, action) => {
      state.ctAppRoles = action.payload;
    },
    setApprovedRegions: (state, action) => {
      state.approvedRegions = action.payload;
    },
    setApprovedPlants: (state, action) => {
      state.approvedPlants = action.payload;
    },
    setRegionPlantMapping: (state, action) => {
      state.regionPlantMapping = action.payload;
    },
    setSelectedRegion: (state, action) => {
      state.selectedRegion = action.payload;
      state.selectedPlant = ""; // reset plant when region changes
    },
    setSelectedPlant: (state, action) => {
      state.selectedPlant = action.payload;
    },
    setUserDetails: (state, action) => {
      state.email = action.payload.email;
      state.name = action.payload.name || "";
    },
    clearApprovedAccess: (state) => {
      state.approvedRegions = [];
      state.approvedPlants = [];
      state.regionPlantMapping = {};
      state.selectedRegion = "";
      state.selectedPlant = "";
    }
  }
});

export const {
  setCtAppRoles,
  setUserDetails,
  setApprovedRegions,
  setApprovedPlants,
  setRegionPlantMapping,
  setSelectedRegion,
  setSelectedPlant,
  clearApprovedAccess
} = userSlice.actions;

export default userSlice.reducer;